require('../../jhire/services/jv.Pending.Approvals.Service');
require('../../jhire/services/jv.Hire.Url.Service');

angular.module('jv.Dashboard.Pending.Approvals.Controller', [
        'jv.Pending.Approvals.Service',
        'jv.Hire.Url.Service'
    ])
    .controller('jv.Dashboard.Pending.Approvals.Controller', ['$scope', 'jvDashboardAjaxService', 'jvContextualLoadingService', '$window', 'Reqs', '$rootScope', 'transformApprovalChain', 'jvHireUrlService',
        function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window, Reqs, $rootScope, transformApprovalChain, jvHireUrlService) {
            $scope.refreshTimestamp = true;
            $scope.expanded = {};
            $scope.isJobApproval = ($scope.widgetObject.subType === 'MyJobApprovals');
            $scope.isOfferApproval = ($scope.widgetObject.subType === 'MyOfferApprovals');
            $scope.currentPage = 0;
            $scope.pageSize = 5;
            $scope.totalCount = 0;
            var postData = {};
            $scope.jvHireUrlService = jvHireUrlService;

            //Handler for refresh_widget
            $rootScope.$on('REFRESH_WIDGET', function(event, widgetData) {
                if (widgetData && ($scope.widgetObject.widgetId === widgetData.widgetId)) {
                    $scope.refreshTimestamp = false;
                    $scope.getPendingApprovals(0);
                }
            });

            var expandAndCloseOthers = function(index) {
                $scope.expanded = {};
                $scope.expanded[index] = true;
            };

            var populateProfileUrls = function(approvalChains) {
                angular.forEach(approvalChains, function(approvalChain) {
                    angular.forEach(approvalChain.approvers, function(approver) {
                        approver.profilePicUrl = '/admin/action/user-details/employee/' + approver.user.EId + '/profilePhoto?size=t';
                        approver.user.profilePicUrl = '/admin/action/user-details/employee/' + approver.user.EId + '/profilePhoto?size=t';
                        angular.forEach(approver.alternateApprovers, function(alternateApprover) {
                            alternateApprover.user.profilePicUrl = '/admin/action/user-details/employee/' + alternateApprover.user.EId + '/profilePhoto?size=t';
                        });
                    });
                });
                return approvalChains;
            };

            //collapse Interview item
            var collapseItem = function() {
                angular.forEach($scope.expanded, function(value, key) {
                    $scope.expanded[key] = false;
                });
            };

            $scope.getPendingApprovals = function(pageNumber) {
                collapseItem();
                jvContextualLoadingService.show($scope.widgetObject.widgetId);
                $scope.currentPage = pageNumber;
                if ($scope.isJobApproval) {
                    postData = {
                        'refreshGrid': 'refresh',
                        'searchAllReq': true,
                        'sortBy': 'lastUpdated',
                        'jobStateValue': 16,
                        'ownerIds': $window._jvselfUser.eid,
                        'awaitingApproval': false,
                        'page': pageNumber,
                        'maxResults': $scope.pageSize,
                        'order': 'desc',
                    };
                    jvDashboardAjaxService.getUserJobApprovals(postData, function(response) {
                        jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                        $scope.refreshTimestamp = true;
                        if (response && response.jobs) {
                            $scope.approvals = response.jobs;
                            if (typeof response.jobCount !== "undefined") {
                                $scope.totalCount = response.jobCount;
                            } else {
                                $scope.totalCount = 0;
                            }
                        } else {
                            //might need to change this later
                            $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                        }
                    });
                } else if ($scope.isOfferApproval) {
                    postData = {
                        'page': pageNumber,
                        'maxResults': $scope.pageSize,
                    };
                    jvDashboardAjaxService.getUserOfferApprovals(postData, function(response) {
                        jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                        $scope.refreshTimestamp = true;
                        if (response && response.applicationApprovalInfo) {
                            $scope.approvals = response.applicationApprovalInfo;
                            $scope.totalCount = response.count;
                        } else {
                            //might need to change this later
                            $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                        }
                    });
                }
            };

            $scope.getApprovalDetails = function(approval, index) {

                if ($scope.expanded[index]) {
                    $scope.expanded[index] = false;
                    return;
                }
                jvContextualLoadingService.show($scope.widgetObject.widgetId);
                if ($scope.isJobApproval) {
                    Reqs.getApprovalChain(approval.EId, function(approvalChain) {
                        if (approvalChain) {
                            jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                            approvalChain = transformApprovalChain(approvalChain);
                            approvalChain = populateProfileUrls(approvalChain);
                            var approvalDetails = angular.copy(approvalChain.reverse());
                            $scope.approvalDetails = approvalDetails.splice(0, 1);
                            expandAndCloseOthers(index);
                        }
                    }, function(err) {
                        $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                    });
                } else if ($scope.isOfferApproval) {
                    postData = {
                        'applicationId': approval.applicationEId,
                        'stateId': approval.candidateStateEId
                    };
                    jvDashboardAjaxService.getUserOfferApprovalDetails(postData, function(response) {
                        if (response && response.workflowActivities && response.workflowActivities.model.offerApproval) {
                            jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                            var approvalChain = response.workflowActivities.model.offerApproval;
                            approvalChain = transformApprovalChain(approvalChain);
                            approvalChain = populateProfileUrls(approvalChain);
                            var approvalDetails = angular.copy(approvalChain.reverse());
                            $scope.approvalDetails = approvalDetails.splice(0, 1);
                            expandAndCloseOthers(index);
                        }
                    }, function(err) {
                        $rootScope.showMsg('ERROR_PROCESSING_REQUEST');
                    });
                }
            };

            $scope.getPendingApprovals(0);
        }
    ]);